<!-- Detailinfo.vue -->
<template>
	<div v-if="detailInfo">
		<div v-if="detailInfo.bargain_info" class="bargain-wrapper">

			<div class="bargain-content" @click="bargainVisible=true">
				<div class="title">Group Bargain</div>
				<div class="content">
					<div>Ends in</div>
					<div><span v-if="day"><em>{{day}}</em>day</span><span><em>{{hours}}</em>:</span><span><em>{{minute}}</em>:</span><span><em>{{second}}</em> </span></div>
				</div>
				<div class="arrow iconfont">&#xe650;</div>
			</div>
			<mt-popup v-model="bargainVisible" position="bottom" class="bargain-popup-wrapper">
				<div class="mt">Rules of Group Bargain</div>
				<div class="mc">
					<div class="line">
						1.Within the validity period of the promotion activity, buyer could invite friends to help to join the bargain. Every time someone joins the bargain, you will get a lower price for the product. Once the price reaches to the target discount price, you could buy the product with the target price.
					</div>
					<div class="line">
						2.Buyer must buy the product within the validity period. After the validity period, the product will be at the regular price again. ；
					</div>
					<div class="line">
						3.For the same product, every buyer can only enjoy the target discount price once.
					</div>
					<div class="line">
						4.The same member can only bargain for a friend once for the same product.
					</div>
					<div class="line">
						5.The quantity of bargain product is limited. You will not be able to buy them after they are sold out.
					</div>
				</div>
			</mt-popup>
		</div>
		<div class="ui-detail-info">

			<div class="info-header ui-flex">
				<h3>{{ detailInfo.goods_name }}<span class="strong">{{ detailInfo.goods_advword }}</span></h3>
				<div class="favorite">
					<i class="iconfont" v-on:click="productUnlike()" v-if="isFavorate">&#xe6d5;</i>
					<i class="iconfont" v-on:click="productLike()" v-else>&#xe6d6;</i>
					<span>{{favoriteName}}</span>
				</div>
			</div>

			<div v-if="detailInfo.wholesale_info" class="price" style="display: flex">
				<div v-for="(item,index) in detailInfo.wholesale_info.wholesalegoods_price" :key="index" style="flex:1">
					<span class="current-price"><i class="price-number">US ${{item.price}}</i></span>
					<span class="num">{{item.num_text}}</span>
				</div>
			</div>
			<div v-else class="price">
			<span class="current-price"><i class="price-number">US $<slot v-if="detailInfo.bargain_info">{{ detailInfo.bargain_info.bargain_floorprice }}</slot><slot v-else-if="detailInfo.pintuan_type">{{ detailInfo.pintuan_price }}</slot><slot v-else-if="detailInfo.promotion_type">{{ detailInfo.promotion_price }}</slot><slot v-else>{{ detailInfo.goods_price }}</slot></i>
			</span>
				<span class="old-price" v-if="detailInfo.goods_marketprice > 0">${{ detailInfo.goods_marketprice }}</span>
			</div>
			<div class="inviter_amount" v-if="detailInfo.inviter_money > 0">
				<span class="inviter_amount" >分销佣金：${{ detailInfo.inviter_money }}</span>
			</div>

			<div v-if="!detailInfo.bargain_info">
				<div class="info-promotions" v-if="detailInfo.pintuan_type=='pintuan'">
					<div class="left">
						<i>拼团</i>
						<span v-if="detailInfo.pintuan_limit_quantity">Up to {{detailInfo.pintuan_limit_quantity}} piece(s) can be purchased</span>
					</div>
					<span class="right">{{fromNow(detailInfo.pintuan_end_time)}}结束</span>
				</div>
				<div class="info-promotions" v-if="detailInfo.promotion_type=='groupbuy'">
					<div class="left">
						<i>Special Deal</i>
						<span v-if="detailInfo.upper_limit">Qty. up to{{detailInfo.upper_limit}} </span>
					</div>
					<span class="right">{{fromNow(detailInfo.promotion_end_time)}}End</span>
				</div>
				<div class="info-promotions" v-if="detailInfo.promotion_type=='xianshi'">
					<div class="left">
						<i>Flash Sale</i>
						<span v-if="detailInfo.lower_limit">Starting Qty: {{detailInfo.lower_limit}}</span>
					</div>
					<span class="right">{{fromNow(detailInfo.promotion_end_time)}}End</span>
				</div>
				<div class="info-promotions" v-if="detailInfo.promotion_type=='presell'">
					<div class="left">
						<i>Presale</i>
						<span v-if="detailInfo.remark">{{detailInfo.remark}}</span>
					</div>
					<span class="right">{{fromNow(detailInfo.presell_end_time)}}End</span>
				</div>
			</div>

			<div class="dss-sale" v-if="detailInfo.goods_mgdiscount_arr">
				<dl>
					<dd class="mgdiscount-info">
						<span v-for="(item,index) in detailInfo.goods_mgdiscount_arr"><em>{{item.level_name}}</em> {{item.level_discount}}折</span>&nbsp;&nbsp;
					</dd>
				</dl>
			</div>
		</div>
	</div>

</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { productLike, productUnlike } from '../../../../api/homegoodsdetail'
import { Toast, Indicator } from 'mint-ui'
export default {
  data () {
    return {
      bargainVisible: false,
      flag: false,
      day: 0,
      hours: 0,
      minute: 0,
      second: 0,
      time: false,
      orderTime: '', // 下单时间
      arrivalsTime: '', // 到达时间
      arrivalsTitle: '', // 到达时间的标题
      arrivalsRange: '' // 到达时间区间,
    }
  },
  computed: {
    ...mapState({
      isFavorate: state => state.goodsdetail.isFavorate,
      detailInfo: state => state.goodsdetail.detailInfo,
      currentProductId: state => state.goodsdetail.currentProductId,
      user: state => state.member.info
    }),
    favoriteName () {
      return this.isFavorate ? 'My Favorite' : 'Favorite'
    }
  },
  created () {
  },
  mounted () {
    this.time = setInterval(() => {
      if (this.flag == true) {
        clearInterval(this.time)
      } else {
        this.timeDown()
      }
    }, 1000)
  },
  methods: {
    ...mapMutations({
      saveInfo: 'saveDetailInfo',
      changeIndex: 'changeIndex',
      saveIsFavorate: 'saveIsFavorate'
    }),
    fromNow (time) {
      return this.$moment(time * 1000).fromNow()
    },
    /*
     * getCommentStatus： 去到评论页面
     */
    getCommentStatus () {
      this.changeIndex(2)
    },
    /*
     * productLike： 收藏商品
     */
    productLike () {
      if (this.user) {
        let id = this.detailInfo.goods_id
        productLike(id).then(res => {
          if (res) {
            this.saveIsFavorate(true)
          }
        }).catch(function (error) {
        Toast("You can't collect your own goods")
      })
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
      }
    },
    /*
     * productUnlike： 取消收藏
     */
    productUnlike () {
      if (this.user) {
        let id = this.detailInfo.goods_id
        productUnlike(id).then(res => {
          if (res) {
            this.saveIsFavorate(false)
          }
        })
      } else {
        this.$router.push({ name: 'HomeMemberLogin' })
      }
    },

    /*
	 * timeDown: 倒计时
	 */
    timeDown () {
      let end_time = false
      if (this.detailInfo.bargain_info) {
        end_time = this.detailInfo.bargain_info.bargain_endtime
      }
      if (end_time) {
        const endTime = new Date(end_time * 1000)
        const nowTime = new Date()
        let leftTime = parseInt((endTime.getTime() - nowTime.getTime()) / 1000)
        this.day = parseInt(leftTime / (24 * 60 * 60))
        this.hours = this.formate(parseInt((leftTime / (60 * 60)) % 24))
        this.minute = this.formate(parseInt((leftTime / 60) % 60))
        this.second = this.formate(parseInt(leftTime % 60))
        if (leftTime <= 0) {
          this.flag = true
          this.detailInfo.bargain_info = ''
          this.saveInfo(this.detailInfo)
        }
      }
    },
    /*
     * 格式化时间
     */
    formate (time) {
      if (time >= 10) {
        return time
      } else {
        return `0${time}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>

h3 span{display: block;font-size: 12px;}

	.bargain-wrapper{
		.bargain-content{
			padding:.5rem;color:#fff;
			background: #EA3F64;background-image: linear-gradient(to right, #ff5e00, #ea3f3f);
			display: flex;
			.title{flex:1;font-size:1rem;line-height: 1.2rem;}
			.content{width:auto;font-size:.6rem;line-height: .6rem;
				em{margin:0 .1rem}
			}
			.arrow{width:1rem;text-align: right;line-height: 1.2rem;}

		}
		.bargain-popup-wrapper{padding:.5rem;color:#333;box-sizing: border-box;padding-bottom: 3rem;
			.mt{font-size:.8rem;text-align: center}
			.mc{font-size:.6rem;
				.line{margin-top:.5rem;}
			}
		}
	}
.ui-detail-info {
	padding: 0 0.75rem;
	background: #ffffff;
	.ui-flex {
		display: flex;
		/*justify-content: space-between;*/
		align-content: center;
		align-items: center;
		flex-basis: 100%;
		width: auto;
	}
	.info-header {
		padding: 0.4rem 0;
		h3 {
			color: #333;
			font-size: 0.7rem;
			padding: 0;
			margin: 0;
			font-weight: normal;
			line-height:1rem;
			width:85%;
      .strong{color:$primaryColor}
		}
		.favorite {
			height:2.4rem;
			text-align:center;
			i{width:2.4rem;display:block;font-size:1.2rem;line-height:1.2rem;color:#e93b3d;}
			span{font-size:0.5rem;line-height:1rem;height:1rem;display:block;}
		}
	}

	.price {
		padding-bottom: 0.4rem;
		display: flex;
		span {
			display: block;
			font-weight: normal;
			&.current-price {
				font-size: 0.6rem;
				color: $primaryColor;
				line-height: 1rem;
        .price-number{font-size:.9rem;}
			}
			&.num{
				font-size: 0.6rem;
				color:#666;
			}
			&.old-price {
				font-size: 0.6rem;
				color: rgba(164, 170, 179, 1);
				line-height: 1rem;
				text-decoration: line-through;
				margin-left: 0.3rem;
			}
		}
	}
	.inviter_amount {
		padding-bottom: 0.4rem;
		display: flex;
		span {
			font-size: .7rem;
			color: #4e545d;
		}
	}

	.info-sub {
		border-bottom: 0.5px solid #e8eaed;
		padding-bottom: 0.25rem;
		p {
			padding: 0;
			margin: 0;
			color: $primaryColor;
			font-size: 0.5rem;
		}
	}

	.info-promotions {
		display: flex;
		justify-content: flex-start;
		align-content: center;
		align-items: center;
		padding: 0.75rem 0;
		border-bottom: 0.5px solid #e8eaed;
		line-height:1.5rem;
		span {
			margin-left: 0.75rem;
			font-size: 0.6rem;
			color: rgba(143, 142, 148, 1);
		}
		img {
			width: 30.4rem;
		}
	}
	.info-promotions i{font-size:.7rem;border:1px solid $primaryColor;color:$primaryColor;padding:0.1rem 0.3rem;border-radius:0.1rem;}
	.info-promotions .left{flex:1}
	.info-promotions .right{width:4rem;text-align: right}

	.dss-sale .mgdiscount-info{font-size:.7rem;color:#666;padding-bottom: .5rem }
	.dss-sale .mgdiscount-info span{margin-right:.5rem;white-space: nowrap;}
	.dss-sale .mgdiscount-info em{background:#f23030;color:#fff;padding: .1rem;font-size:.6rem;}
}
</style>
